var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var treeEquipment = require('../../locations/treeEquipment');
var loaders = require('../../layout/components/loaders');
var measurableModel = require('../../measurable/models/measurable');
var serviceTaxonomy = require('../../service/serviceTaxonomy');

var addFeedsEdgeModal = Object.assign(Object.create(Model), require('../../../../../models/equipment/feeds'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


addFeedsEdgeModal.editDialogue = function (record, originEquipmentRecord, originPort, options) {
  options = options || {};
  var initObj = {};
  if (record) {
    var targetEquipment = normalizeEquipmentRecord(options.invertEquipment ? record.out : record.in);
    initObj = {
      '@rid':  record['@rid'],
      toNode: targetEquipment,
      fromNode: originEquipmentRecord['@rid'],
    }
  } else {
    initObj = {
      fromNode: originEquipmentRecord['@rid'],
    }
  }

  Model.initForm.call(addFeedsEdgeModal, initObj);

  addFeedsEdgeModal.form.originPort = prop(originPort);
  addFeedsEdgeModal.form.destinyPort = prop();
  addFeedsEdgeModal.form.invertEquipment = prop(options.invertEquipment ? true : false);
  addFeedsEdgeModal.loadingEquipment = prop(false);

  var submit = function () {

    if(!addFeedsEdgeModal.form.toNode() || !addFeedsEdgeModal.form.originPort() ||!addFeedsEdgeModal.form.destinyPort()) {
      addFeedsEdgeModal.errors = [];
      addFeedsEdgeModal.errors.push('Please select an Equipment and a Port to connect to.');
      redraw();
      return false;
    }

    var fromNode, toNode, originPort, destinyPort, category;
    if (options.invertEquipment) {
      fromNode = addFeedsEdgeModal.form.toNode()['@rid'];
      toNode = addFeedsEdgeModal.form.fromNode();
      originPort = addFeedsEdgeModal.form.destinyPort();
      destinyPort = addFeedsEdgeModal.form.originPort();
      category = serviceTaxonomy.getServiceClass(originPort);
    } else {
      fromNode = addFeedsEdgeModal.form.fromNode();
      toNode = addFeedsEdgeModal.form.toNode()['@rid'];
      originPort = addFeedsEdgeModal.form.originPort();
      destinyPort = addFeedsEdgeModal.form.destinyPort();
      category = serviceTaxonomy.getServiceClass(originPort);
    }

    addFeedsEdgeModal.form.fromNode(fromNode);
    addFeedsEdgeModal.form.fromPortId(originPort.id);

    addFeedsEdgeModal.form.toNode(toNode);
    addFeedsEdgeModal.form.toPortId(destinyPort.id);

    addFeedsEdgeModal.form.serviceClass(category);
    addFeedsEdgeModal.form.category(category);


    return addFeedsEdgeModal.save()
    .then(function (response) {
      options && options.submitCallback ? options.submitCallback() : '';
      key.unbind('enter');
      modal.vm.close();
    })

  };

  addFeedsEdgeModal.handleEquipmentSelect = function (node) {
    addFeedsEdgeModal.form.destinyPort(null);
    if (!node || !node['@rid']) {
      addFeedsEdgeModal.form.toNode('');
      addFeedsEdgeModal.loadingEquipment(false);
      return null;
    }
    addFeedsEdgeModal.loadingEquipment(true);
    return loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/equipment/' + node['@rid'].slice(1),
      method: 'GET'
    })
      .then(function (fullRecord) {
        addFeedsEdgeModal.form.toNode(fullRecord);
        addFeedsEdgeModal.form.destinyPort(getAutoSelectedCompatiblePort(fullRecord, addFeedsEdgeModal.form.originPort()));
        addFeedsEdgeModal.loadingEquipment(false);
        return fullRecord;
      })
      .catch(function (err) {
        console.error('Unable to load equipment record', err);
        addFeedsEdgeModal.form.toNode(node);
        addFeedsEdgeModal.loadingEquipment(false);
        return node;
      });
  };

  if (record) {
    initializeExistingConnectionTarget(record, options);
  }

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(
    record ?
      originPort.type == 'output' ?
        `Edit Connection from ${originPort.name} (${serviceTaxonomy.getServiceClass(originPort)}) into:`
      :
        `Edit Connection into ${originPort.name} (${serviceTaxonomy.getServiceClass(originPort)}) from:`
    :
      originPort.type == 'output' ?
        `Connect from ${originPort.name} (${serviceTaxonomy.getServiceClass(originPort)}) into: `
      :
        `Connect into ${originPort.name} (${serviceTaxonomy.getServiceClass(originPort)}) from:`
  );
  modal.vm.body = addFeedsEdgeModal.view,

  record ?
    modal.vm.buttons([
      {
        label: "Delete",
        class: "dib mr2 red",
        func: () => {
          addFeedsEdgeModal.delete(record)
          .then(function (response) {
            options && options.submitCallback ? options.submitCallback() : '';
            key.unbind('enter');
            modal.vm.close();
          })
          .catch(function (err) {
            console.error('Unable to delete feed edge', err);
            addFeedsEdgeModal.errors = addFeedsEdgeModal.errors || [];
            addFeedsEdgeModal.errors.push('Unable to delete connection right now.');
          });
        }
      },
      {
        label: "Save",
        class: "dib green",
        func: submit
      }
    ])
  :
    modal.vm.buttons([
      {
        label: "Save",
        class: "dib green",
        func: submit
      }
    ])

  modal.vm.open();
}


addFeedsEdgeModal.view = function () {
  var targetEquipment = addFeedsEdgeModal.form.toNode();
  var ports = getPorts(targetEquipment);
  return m('form', {role:'form'}, [
    addFeedsEdgeModal.errorView(),
    m(treeEquipment, {
      selectedNode: addFeedsEdgeModal.form.toNode,
      excludedRid: addFeedsEdgeModal.form.fromNode(),
      onSelect: addFeedsEdgeModal.handleEquipmentSelect
    }),
    targetEquipment
      ? addFeedsEdgeModal.loadingEquipment()
        ?
          m('div.w-100.flex.justify-center.mt2', [
            m('img.h1.mr2', { src: '/images/loading-bars.svg' })
          ])
        : ports.length
          ? [
              m('div', 'Ports:'),
              m('select', {
                onchange: function(ev) {
                  const selectedPortId = ev.target.value;
                  addFeedsEdgeModal.form.destinyPort(findPortById(targetEquipment, selectedPortId));
                },
                value: addFeedsEdgeModal.form.destinyPort() ? addFeedsEdgeModal.form.destinyPort().id : ''
              }, [
                m('option', {
                  value: '',
                  disabled: true
                }, 'Select a port'),
                ports
                .map(port => {
                  let disableOption = !isCompatiblePort(port, addFeedsEdgeModal.form.originPort());
                  return m('option', {
                    value: port.id,
                    disabled: disableOption
                  }, `${port.id} - ${port.name} (Type:${port.type} - Service: ${serviceTaxonomy.getServiceClass(port)})`);
                })
              ])
            ]
          : m('div', 'The equipment selected lacks ports for connectivity')
      : m('div', '')
  ])
}

function initializeExistingConnectionTarget(record, options) {
  var targetPortId = options.invertEquipment ? record.fromPortId : record.toPortId;
  var targetEquipment = addFeedsEdgeModal.form.toNode();
  var selectedPort = findPortById(targetEquipment, targetPortId);
  if (selectedPort) {
    addFeedsEdgeModal.form.destinyPort(selectedPort);
    return;
  }

  if (!targetEquipment || !targetEquipment['@rid']) return;

  addFeedsEdgeModal.loadingEquipment(true);
  addFeedsEdgeModal.handleEquipmentSelect(targetEquipment)
    .then(function (fullRecord) {
      addFeedsEdgeModal.form.destinyPort(findPortById(fullRecord, targetPortId));
      redraw();
    });
}

function redraw() {
  if (typeof window !== 'undefined' && typeof m.redraw === 'function') {
    try {
      m.redraw();
    } catch (error) {}
  }
}

function normalizeEquipmentRecord(record) {
  if (!record) return record;
  if (typeof record === 'string') return { '@rid': record };
  if (record['@rid']) return record;
  if (typeof record.toString === 'function') return { '@rid': record.toString() };
  return record;
}

function getPorts(equipmentRecord) {
  if (!equipmentRecord || !equipmentRecord.ports || !isPlainObject(equipmentRecord.ports)) return [];
  return Object.keys(equipmentRecord.ports).map(function (key) {
    return equipmentRecord.ports[key];
  });
}

function findPortById(equipmentRecord, portId) {
  if (portId == null || portId === '') return null;
  return getPorts(equipmentRecord).filter(function (port) {
    return port && String(port.id) == String(portId);
  })[0] || null;
}

function getCompatiblePorts(equipmentRecord, originPort) {
  return getPorts(equipmentRecord).filter(function (port) {
    return isCompatiblePort(port, originPort);
  });
}

function getAutoSelectedCompatiblePort(equipmentRecord, originPort) {
  var compatiblePorts = getCompatiblePorts(equipmentRecord, originPort);
  return compatiblePorts.length === 1 ? compatiblePorts[0] : null;
}

function isCompatiblePort(port, originPort) {
  if (!port || !originPort) return false;
  if (port.type == originPort.type) return false;

  let fromPort = originPort.type == 'output' ? originPort : port;
  let toPort = originPort.type == 'input' ? originPort : port;
  let fromServiceClass = serviceTaxonomy.getServiceClass(fromPort);
  let toServiceClass = serviceTaxonomy.getServiceClass(toPort);
  let decendentClass = isDescendantOf(fromServiceClass, toServiceClass, measurableModel.measurableClassTree.categories || []);

  return (
    serviceTaxonomy.getServiceClass(port) == serviceTaxonomy.getServiceClass(originPort) ||
    decendentClass
  );
}

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function isDescendantOf(parentClass, childClass, measurableClassTree) {
  for (let measurableClass of measurableClassTree) {
    if (measurableClass.name === parentClass) {
      return isChildOrDescendant(childClass, measurableClass.children);
    }
    if (isDescendantOf(parentClass, childClass, measurableClass.children)) {
      return true;
    }
  }
  return false;
}

function isChildOrDescendant(childClass, children) {
  for (let child of children) {
    if (child.name === childClass) {
      return true;
    }
    if (child.children && child.children.length > 0) {
      if (isChildOrDescendant(childClass, child.children)) {
        return true;
      }
    }
  }
  return false;
}

module.exports = addFeedsEdgeModal;

addFeedsEdgeModal._private = {
  findPortById,
  getAutoSelectedCompatiblePort,
  getCompatiblePorts,
  isCompatiblePort,
  normalizeEquipmentRecord
};
